import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import ReloadCountBack from "../../../components/countback";
import {useLocation, useNavigate} from "react-router-dom";
import associateServices from "../../../services";
import Loading from "../../../components/loading";
import InstrumentIcon from "../../../components/instrument-icon";
import Big from "big.js";
import {useSelector} from "react-redux";
import SvgIcon from "../../../components/svg-icon";
import stringHelper from "../../../helpers/string-helper";

const RaceModal = props => {

    const {activeLanguage} = useSelector(state => state.globalReducer)
    const navigate = useNavigate()
    const {handleClose} = props
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language

    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)
    const location = useLocation()

    const getParams = (key) => {
        const searchParams = new URLSearchParams(location?.search);
        return searchParams.get(key);
    }

    useEffect(() => {
        const bdy = document.body
        bdy.classList?.add('modal-open')
        const mdl = document.getElementById('race-modal')
        mdl.classList?.add('show')
        mdl.style.display = 'block'
        mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

        getRaceDetail(getParams('uuid'), activeLanguage?.key)
    }, [location?.search, activeLanguage?.key])

    const getRaceDetail = (uuid, language) => {
        if (language) {
            associateServices.getRaceDetail({
                uuid,
                language
            }).then(res => {
                setData(res?.data)
                setLoading(false)
            })
        }
    }


    const handleRaceDetail = () => {
        navigate(stringHelper.getLocalizedPath(currentLanguage, `/race/detail/${data?.race?.uuid}`))
    }

    return (
        <div
            className="modal fade show"
            id="race-modal"
            aria-labelledby="race-modal"
            onClick={handleClose}>

            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    {
                        loading ? <Loading/> :
                            <div className="modal__content">
                                <div className="modal__head">
                                    <h6 className="modal__title">{data?.race?.title}</h6>
                                    <button
                                        className="modal__close"
                                        type="button"
                                        onClick={handleClose}
                                    >
                                        <SvgIcon id={'x'}/>
                                    </button>
                                </div>
                                <div className="bet">
                                    <ReloadCountBack
                                        showDesc={false}
                                        nextDate={data?.race?.end}/>

                                    <ul className="bet__info">
                                        <li>
                                            <span>{t('modals.races.your-position')}</span>
                                            <div className="xtable__text">
                                                {data?.sort?.order_sort || '-'}
                                            </div>
                                        </li>
                                        <li>
                                            <span>{t('modals.races.your-current-prize')}</span>
                                            <div className="xtable__coin xtable__coin--green">
                                                <InstrumentIcon code={'USDT'}/>
                                                ${data?.sort?.prize || '0.00'}

                                            </div>
                                        </li>
                                        <li>
                                            <span>{t('modals.races.your-wager')}</span>
                                            <div className="xtable__coin xtable__coin--green">
                                                <InstrumentIcon code={'USDT'}/>
                                                ${Big(data?.wager || 0).toFixed(2)}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <p className="form__description">
                                    {/*{t('modals.races.description')}*/}
                                    {data?.race?.description}
                                </p>
                                <div className="settings__btns settings__btns--modal">
                                    <a onClick={handleRaceDetail} className="settings__btn settings__btn--clean">
                                        {t('modals.races.read-more')}
                                    </a>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>

    )

}

export default RaceModal
